import { SidebarIcon } from '@braskai/icons';
import { useDeviceType } from '@braskai/ui-kit';

import { useInterfaceLanguage } from '@/shared/i18n';

import { SSidebarButton } from './styled';

type SidebarButtonProps = {
  locked?: boolean;
  onClick?: () => void;
};

export const SidebarButton = ({ locked, onClick }: SidebarButtonProps) => {
  const { t } = useInterfaceLanguage();
  const { isDesktop, isLaptop } = useDeviceType();

  if (!(isLaptop || isDesktop)) {
    return null;
  }

  return (
    <SSidebarButton
      title={t(locked ? 'common.hideSidebar' : 'common.lockSidebar')}
      $locked={locked}
      data-testid="sidebar-button"
      startIcon={<SidebarIcon height={16} width={16} />}
      variant="text"
      onClick={onClick}
    />
  );
};
